import React, { useCallback, useEffect, useRef, useState } from 'react';
import Axios from '../../../axios-proas'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { EntOwnersSelect, AddOwner, SearchOwner, SelectOwnersHeader, SelectOwnersItem, SelectOwnersItems, SelectOwnersList, ItemLabelParentLevel, ItemLabel, ItemLabelLevel, ItemCode, SelectContainerLevel, SelectContainer, SelectOwnersListLevel,SelectOwnersItemsLevel } from './DropDown.styled';
import { useTranslation } from 'react-i18next';
import { BtnIcon, PrimaryBtnOutlineAction, SearchInput, SearchInputContainer, PrimaryBtnOutlineActionModal, SecondaryBtnOutlineActionModal } from "../../../styles/Common";
import MandatoryMarker from '../../UI/MandatoryMarker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Draggable from "react-draggable";
import { getNotyfObject } from '../../../shared/utility';
import { faEnvelope, faUser, faDolly, faPersonRays, faUserGear, faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { Resizable } from 're-resizable';
import { CTooltip } from '../../../components/UI/CTooltip/CTooltip';
function DropDownLevel({ niveau, entities, listItemsAlreadyExistes, indexLevel, addEntitiesUser, setSearchQueryHierarchie, searchQueryHierarchie, requestParams }) {
    const { t } = useTranslation();
    const [showEntityModal, setShowEntityModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null)

    const [items, setItems] = useState(listItemsAlreadyExistes)
    const notyf = getNotyfObject();

    useEffect(() => {

        setItems(listItemsAlreadyExistes)

    }, [listItemsAlreadyExistes])



    const SelectEntity = (entity) => {

        let entityIndex = items?.findIndex(row => row.libelle === entity.libelle);
        let selectedTemp = [...items];
        if (entityIndex < 0)
            selectedTemp = [...items, entity];
        setItems(selectedTemp)

    }


    const deleteItem = (entity) => {
        let userEntity = [...items]
        let entityIndex = items.findIndex(ent => ent.libelle === entity.libelle);
        if (entity.index == niveau.length - 1) {
            if (entityIndex >= 0) {
                userEntity.splice(entityIndex, 1)
            }
        } else {
            let libelle = niveau[entity.index].libelle
            let value = entity.libelle
            let nextElement = listItemsAlreadyExistes?.filter((iteme, id) => iteme.index == entity.index + 1)
            let existe = nextElement.some((item) => item[libelle] == value)
            if (existe) {
                notyf.error("vous ne pouvez pas supprimer cette ligne avant de supprimer les ligne(s) attacheé(s) a cette derniere");

            } else {
                if (entityIndex >= 0) {
                    userEntity.splice(entityIndex, 1)
                }

            }

        }

        setItems(userEntity)
    }

    return (
        <>

            <AddOwner >
                <FontAwesomeIcon icon={faCirclePlus} style={{ color: "#2174b980", fontSize: "1rem" }} onClick={() => setShowEntityModal(!showEntityModal)} />
                {
                    showEntityModal && (
                        <Draggable >
                                
                            <SelectContainerLevel >
                              
                               
                                <Resizable
                                    defaultSize={{ width: 320, height: 250 }}
                                    minWidth={330}
                                    minHeight={250}
                                    maxWidth="80vw"
                                    maxHeight="80vh"
                                >
                                    <small style={{ fontSize: "0.75rem", color: "#888", paddingLeft:"7px"}}>
                                        {("Vous pouvez déplacer ou redimensionner cette fenêtre")}
                                    </small>
                                    <SearchOwner>
                                        <SearchInput
                                            placeholder="Rechercher"
                                            type="text"
                                            onChange={(e) => setSearchQueryHierarchie(e.target.value)}
                                            value={searchQueryHierarchie || ''}
                                        />
                                        <SearchIcon style={{ fontSize: "0.9rem" }} />
                                    </SearchOwner>
                                    <SelectOwnersListLevel >

                                        <SelectOwnersItemsLevel >
                                            {
                                                entities?.length > 0 ? entities.map(entity => (
                                                    <SelectOwnersItem key={entity?.libelle} onClick={() => SelectEntity({ index: entity.index, libelle: entity.libelle, code: entity.code, ...entity })}>
                                                        <input type='checkbox' checked={items?.findIndex(row => row.libelle === entity.libelle) >= 0} style={{ marginRight: '0.5rem' }}
                                                            onChange={(e) => {
                                                                items?.findIndex(row => row.libelle === entity.libelle) >= 0 ? deleteItem(entity) : SelectEntity({ index: entity.index, libelle: entity.libelle, code: entity.code, ...entity })
                                                            }}
                                                        />
                                                        <ItemLabelLevel>{entity?.libelle}</ItemLabelLevel>
                                                        {/*<ItemCode>{entity?.code}</ItemCode>*/}
                                                        <ItemLabelParentLevel>{entity?.index == 0 ? "" : entity[niveau[entity?.index - 1].libelle]}</ItemLabelParentLevel>
                                                    </SelectOwnersItem>
                                                )) : <div style={{ whiteSpace: "nowrap" }}>
                                                    {t('mandat:noAgencies', "Aucune donneé à afficher")}
                                                </div>
                                            }
                                        </SelectOwnersItemsLevel>

                                        <div style={{ display: "flex", justifyContent: "center", width: "auto", paddingTop: "8px" }}>
                                            <PrimaryBtnOutlineActionModal>
                                                <DoneIcon onClick={e => { addEntitiesUser(items, indexLevel), setShowEntityModal(false), setSearchQueryHierarchie("") }} />
                                            </PrimaryBtnOutlineActionModal>

                                            <SecondaryBtnOutlineActionModal>
                                                <CloseIcon onClick={e => { setShowEntityModal(false), setSearchQueryHierarchie("") }} />
                                            </SecondaryBtnOutlineActionModal>

                                        </div>

                                    </SelectOwnersListLevel>
                                </Resizable>
                            </SelectContainerLevel>

                           
                        </Draggable>
                    )
                }
            </AddOwner>



        </>
    );
}

export default DropDownLevel;





